<a [routerLink]="getLangLink()" style="text-decoration: none;" [queryParams]="params" translateToggler class="lang-logo">
  <span class="span" [ngClass]="{'animation-btn-lang': show}" [textContent]="lang"></span>
  <span class="desktop">{{'locale' | transloco}}</span>
</a>
